import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import { construireBudgetTemplate } from '../conventionEtude/ConstruireBudgetTemplate.js';
import { construireDonneesCommunes } from '../construireDonneesCommunes.js';

// ⚠️ Template à créer : /public/templates/Devis.docx
// Mêmes conventions de nommage de balises que la Convention d'Étude
// (voir la liste des Ctrl+H fournie précédemment pour les balises budget :
// {sousTotalHT}, {montantTVA}, {totalTTC}, {pourcentageSignature}, etc.
// + les balises communes : {refDocument}, {identiteClient}, {mailClient}...)
const CHEMIN_TEMPLATE = '/templates/Devis.docx';

function construireDonneesDevis(formData, numDoc) {
  const nombreIntervenant = parseInt(formData.commun.nombreIntervenants, 10) || 0;
  const donneesCommunes = construireDonneesCommunes(formData, 'Devis', numDoc);
  const budgetData = construireBudgetTemplate(formData);
  const { dateValidite } = formData.documents.devis;
  return {
    ...donneesCommunes,
    ...budgetData,
    nombreIntervenant,
    dateValiditeDevis : dateValidite,
    etudeOuCadre : "d'Étude", //à demander ce que représenter convention de cadre.
  };
}

async function genererDevis(formData, numDoc) {
  const reponse = await fetch(CHEMIN_TEMPLATE);
  if (!reponse.ok) {
    throw new Error(`Impossible de charger le template (${reponse.status})`);
  }
  const zip = new PizZip(await reponse.arrayBuffer());
  const doc = new Docxtemplater(zip, { paragraphLoop: true, linebreaks: true });

  const donnees = construireDonneesDevis(formData, numDoc);

  try {
    doc.render(donnees);
  } catch (error) {
    console.error('Erreur de génération du devis :', error);
    if (error.properties && error.properties.errors) {
      console.error(JSON.stringify(error.properties.errors, null, 2));
    }
    throw error;
  }

  const blob = doc.getZip().generate({
    type: 'blob',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });

  saveAs(blob, `${donnees.refDocument}.docx`);
}

export default genererDevis;